import * as React from 'react'
import { ImageCard } from '@revelrygroup/components'
import Link from 'next/link'

import { Case, CaseServiceOffering, ObituarySnippet, Venue } from '../../types'
import EventTrackingModel from '../models/EventTrackingModel'
import { formatDateFromISOString, formatTimeRangeFromISOStrings } from '../../utils/date'
import { routes } from '../../routes'
import styles from './styles.module.scss'

interface Props {
  obituary: ObituarySnippet | Case
  service: CaseServiceOffering
  timeZone: string
}

const venueAddress = (venue: Venue): string => {
  return [
    venue.address_line_1,
    venue.address_line_2 && `(${venue.address_line_2}),`,
    `${venue.city},`,
    `${venue.state}${venue.zip ? ',' : ''}`,
    venue.zip,
  ]
    .filter(Boolean)
    .join(' ')
}

export const Service: React.FC<Props> = ({ obituary, service, timeZone }) => {
  const { venue } = service
  const addressString = venueAddress(venue)

  return (
    <ImageCard imageAlt={venue.name} imageURL={venue.image} key={service.starts_at}>
      {service.starts_at && (
        <p className={styles.startsAt}>
          {formatDateFromISOString(service.starts_at, timeZone)}
          {'  '}
          {formatTimeRangeFromISOStrings(service.starts_at, service.ends_at, timeZone)}
        </p>
      )}

      <h3 className={styles.heading}>{service.service_offering_name}</h3>

      <p className={styles.address}>{venue.name}</p>
      <p className={styles.address}>{addressString}</p>

      <div className={styles.ctaWrapper}>
        <Link href={routes.flowerstore(obituary)}>
          <a className={styles.sendFlowersLink}>Send Flowers</a>
        </Link>

        <a
          className={styles.directions}
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            addressString,
          )}`}
          onClick={() => EventTrackingModel.trackGetDirections()}
        >
          Get Directions
        </a>
      </div>
    </ImageCard>
  )
}
